import { Tabs as MuiTabs, styled } from "@mui/material";
import React from "react";
const classes = { scrollButtonsDesktop: "tabs-scrollButtonsDesktop" };
const StyledMuiTabs = styled(MuiTabs)(({ theme }) => ({
    [`&.${classes.scrollButtonsDesktop}`]: {
        [theme.breakpoints.down("sm")]: {
            display: "inline-block" // overrides the Material-ui styling so that in scrollable variant, the scrollbuttons will remain if in mobile view.
        }
    }
}));
export const Tabs = ({ value, onChange, children, "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy, centered, variant }) => {
    return (React.createElement(StyledMuiTabs, { value: value, indicatorColor: "primary", textColor: "primary", onChange: onChange, "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy, centered: variant == "scrollable" ? false : centered, variant: variant, selectionFollowsFocus: true, classes: { scrollButtons: classes.scrollButtonsDesktop } }, children));
};
//Prop defaults
Tabs.defaultProps = {
    variant: "standard",
    centered: false
};
